<template>
  <div class="products-select">
    <h1 class="title">
      Buy Credits
    </h1>
    <p class="description">Credits unlock coaching sessions with our Pros</p>
    <div class="products">
      <Product
        v-for="product in products"
        :product="product"
        :key="product.id"
      />
    </div>
    <div v-if="!isUserPro">
      <h2 class="benefit-title">PRO MEMBERSHIP BENEFITS</h2>
      <div class="benefits">
        <span class="benefit">
          <img src="@/assets/images/icons/check_light_blue.svg" alt="check" />
          Unlock all courses for every game
        </span>
        <span class="benefit">
          <img src="@/assets/images/icons/check_light_blue.svg" alt="check" />
          Chat with coaches for free
        </span>
        <span v-if="maxDiscount" class="benefit">
          <img src="@/assets/images/icons/check_light_blue.svg" alt="check" />
          {{ maxDiscount }}% off live coaching
        </span>
      </div>
      <button class="join-btn" @click="joinPro">
        JOIN PRO NOW
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import Product from "./Product"

export default {
  components: {
    Product,
  },
  computed: {
    ...mapGetters("Store", ["products", "maxDiscount"]),
    ...mapGetters("User", ["isUserPro", "getUser"]),
    ...mapGetters("Store", ["subscriptionOptions"]),
  },
  methods: {
    ...mapActions("Store", ["fetchProducts"]),
    ...mapActions("Store", ["getSubscriptionOptions"]),
    joinPro () {
      window.location.href = "/store/subscriptions"
    },
    trackViewedProduct () {
      try {
        for (let product of this.products) {
          const item = {
            ProductName: `${product.amount} Points`,
            Price: product.price,
            URL: window.location.href,
          }
          window._learnq.push(["track", "Viewed Product", item])
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
  created () {
    this.fetchProducts()
    this.getSubscriptionOptions()
  },
  mounted () {
    this.trackViewedProduct()
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";
.products-select {
  .title {
    font-size: 2.75rem;
    font-weight: 400;
    font-family: $font-primary;
    color: #000;
    margin-bottom: 1rem;
  }
  .description {
    color: #838d9a;
    font-weight: 300;
    font-family: $font-primary;
    font-size: 1.6rem;
    margin-bottom: 5rem;
  }
  .products {
    display: flex;
    justify-content: center;
    @include tablet-down {
      flex-direction: column;
      align-items: center;
    }
  }
  .benefit-title {
    margin-top: 3rem;
    font-family: $font-primary;
    font-weight: 500;
    font-size: 1.5rem;
    letter-spacing: 0.2em;
    color: #3b3b3b;
    margin-bottom: 1.5rem;
  }
  .benefits {
    display: flex;
    justify-content: center;
    margin-bottom: 4rem;
    @include tablet-down {
      flex-direction: column;
      align-items: center;
    }
    .benefit {
      font-family: $font-primary;
      color: #3b3b3b;
      font-size: 1.6rem;
      font-weight: 300;
      margin: 0 1rem;
      display: flex;
      align-items: center;

      @include phone-down {
        margin-bottom: 1rem;
      }
      img {
        height: 1rem;
        margin-right: 0.5rem;
      }
    }
  }
  .join-btn {
    font-family: $font-primary;
    font-weight: 600;
    color: #fff;
    font-size: 1.6rem;
    background: #141417;
    border-radius: 4px;
    width: 26rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 6rem;
    outline: none;
    border: none;
    &:hover {
      background: #3b3b3b;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/store/pointStore/ProductSelect.vue